import { supabase } from './supabase'

// Cliente da API interna (/api/*). O front NUNCA chama Stripe/ClickSign/Supabase-admin direto.
async function authHeaders(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession()
  const token = data.session?.access_token
  return token ? { authorization: `Bearer ${token}` } : {}
}

export async function apiPost<T>(path: string, body: unknown, opts: { auth?: boolean } = {}): Promise<T> {
  const headers: Record<string, string> = { 'content-type': 'application/json' }
  if (opts.auth) Object.assign(headers, await authHeaders())
  const res = await fetch(path, { method: 'POST', headers, body: JSON.stringify(body) })
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>
  if (!res.ok) throw new Error((data.error as string) || `Erro ${res.status}`)
  return data as T
}
